import React from "react";

export const taxStartGuideContent = {
  texts: {
    subtitle: "Here are some tips and setup tasks to help you get started",
    goal: "Use this guide to get ready for your first tax return.",
    allDone: "You've completed all setup tasks!",
    showPreviousTasks: "Show previous tasks",
    tasksLeft: ({ tasksLeft, minutesLeft }) =>
      `${tasksLeft} tasks left (About ${minutesLeft} minutes)`,
  },
  steps: {
    1: {
      name: "Fill your profile",
      category: "required",
      description: (
        <>
          Use the English language to fill in your address and company name.
          Information from your profile is used in VAT returns.
        </>
      ),
      actions: [
        { label: "Go to profile", to: "/profile", variant: "primary" },
      ],
    },
    2: {
      name: "Add a store",
      category: "recommended",
      description: (
        <>
          Connect your Amazon, Shopify, marketplace, or custom store. You can
          configure a domestic country for every store.
        </>
      ),
      actions: [
        { label: "Create store", to: "/stores/add", variant: "primary" },
      ],
    },
    3: {
      name: "Fill tax settings",
      category: "required",
      description: (
        <>
          Add and activate your VAT numbers or sales tax permits before
          uploading transactions because they affect tax calculations.
        </>
      ),
      actions: [
        { label: "Fill tax settings", to: "/settings", variant: "primary" },
      ],
    },
    4: {
      name: "Upload transactions",
      category: "required",
      description: "Upload transactions using a marketplace integration, spreadsheet, API, or plugin.",
      bullets: [
        "Marketplace integration",
        "Manual upload from an Excel spreadsheet",
        "Real-time API integration",
        "Magento or WooCommerce plugins",
      ],
      actions: [
        {
          label: "Upload transactions",
          to: "/transactions/import",
          variant: "primary",
        },
      ],
    },
  },
};
